export class CloudVendor {
  id: number;
  displayName: string;
  vendorName: string;

  constructor(id?: number, displayName?: string, vendorName?: string) {
    this.id = id;
    this.displayName = displayName;
    this.vendorName = vendorName;
  }
}
